let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g0HXM")).then(() => parcelRequire('41MLY'));